<template>
  <div class="section-sub-about" :class="[{ 'is-alt': isAlt }]" data-aos="fade-up" data-aos-once="true">

    <!-- header -->
    <page-subheader :title="paragraph.title"></page-subheader>

    <div-container>
      <div-columns class="is-hidden-desktop" v-if="imageUrl">
        <div class="columns is-gapless is-centered is-flex-mobile is-vcentered">
          <div class="column is-5 has-text-centered">
            <!-- duplicate implementation for mobile -->
            <a :href="imageLink" target="_blank">
              <img :src="imageUrl" width="300" style="width:300px;padding:30px;" v-if="imageUrl" />
            </a>
          </div>
        </div>
      </div-columns>
      <div-columns paddingTop="0.5em" :class="{ 'with-image': imageUrl !== undefined }" >
        <!-- duplicate implementation for desktop -->
        <a :href="imageLink" target="_blank">
          <img class="is-hidden-touch" :src="imageUrl" width="300" style="width:300px;padding:50px;float:left;" v-if="imageUrl" />
        </a>
        <span v-html="paragraph.content" />
      </div-columns>

      <!-- <div class="control notification is-danger" v-if="error">
        <button class="delete" @click="error = undefined"></button>
        <p v-html="error">
        </p>
      </div> -->

    </div-container>
  </div>
</template>

<script>
import Site from '@/apis/Site'
import DivContainer from '@/components/DivContainer'
import DivColumns from '@/components/DivColumns'
import PageSubheader from '@/components/PageSubheader'
import ShowDown from 'showdown'
import 'showdown-target-blank'

export default {
  name: 'sub-about',
  props: ['name', 'is-alt'],
  components: {
    DivContainer,
    DivColumns,
    PageSubheader
  },
  data () {
    return {
      paragraph: {
        title: '',
        content: ''
      },
      imageUrl: undefined,
      imageLink: undefined,
      error: undefined,
      loading: false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    getItems: function (onComplete) {
      this.loading = true
      this.error = undefined
      this.imageUrl = undefined
      this.imageLink = undefined
      this.paragraph.content = ''
      this.paragraph.title = ''
      Site.aboutWithName(this.name)
      .then((data) => {
        this.loading = false
        // console.log(data)
        if (!data || !data.content) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }

        var converter = new ShowDown.Converter({ extension: ['targetblank'] })
        var html = converter.makeHtml(data.content)
        this.paragraph.content = html
        this.paragraph.title = data.title
        this.imageUrl = data.image ? data.image.path : undefined
        this.imageLink = data.link ? data.link : undefined

        if (onComplete) {
          onComplete(data)
        }
      })
      .catch((error) => {
        this.loading = false
        this.error = 'Unable to load, please kindly refresh the page.'
        console.log(error)
      })
    },

    refresh: function () {
      this.getItems((item) => {
        // this.item = item
      })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section about

.section-sub-about {
  &.is-alt {
    background-color: $color-orange;
  }

  padding-top: 3rem;
  padding-bottom: 3rem;

  @import "../styles/markdown.scss";
}

</style>



// WEBPACK FOOTER //
// AboutSubSection.vue?3a6ce874